var map = {
	"./buffer": 645,
	"./buffer.js": 645,
	"./console": 646,
	"./console.js": 646,
	"./dns": 647,
	"./dns.js": 647,
	"./empty": 55,
	"./empty.js": 55,
	"./net": 648,
	"./net.js": 648,
	"./process": 649,
	"./process.js": 649,
	"./punycode": 650,
	"./punycode.js": 650,
	"./tls": 651,
	"./tls.js": 651,
	"./tty": 652,
	"./tty.js": 652
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1900;



//////////////////
// WEBPACK FOOTER
// ./~/node-libs-browser/mock ^\.\/.*$
// module id = 1900
// module chunks = 0